// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"2f97edeb","278":"b8aa2a7f","287":"91862974","390":"8e596a4b","777":"8a84b9f2","803":"18b91bf7","898":"41167622","921":"bfa70700","930":"61401a99","997":"771a7343"}[chunkId] + ".chunk.js";
};